import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage } from "./Components/LandingPage/LandingPage";
import { Layout } from "./Components/Layout/Layout";
import { ConsentForm } from "./Components/Provider/ConsentForm";
import { ProviderForm } from "./Components/ProviderFrom/ProviderForm";
import { ConsigneeInfo } from "./Components/Provider/ConsigneeInfo";
import { AlternateProductForm } from "./Components/User/AlternateProductForm";
import { UserForm } from "./Components/UserForm/UserForm";
import { Confirmation } from "./Components/Confirmation/Confirmation";
import { CountrySelection } from "./Components/CountryAndLanguage/CountrySelection";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CountrySelection />} />
        {/* <Route path="/" element={<Layout />}>
          <Route index element={<CountrySelection />} /> */}
        <Route element={<Layout />}>
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/consignee" element={<ConsigneeInfo />} />
          <Route path="/consent" element={<ConsentForm />} />
          <Route path="/provider-form" element={<ProviderForm />} />
          <Route path="/alternate-product" element={<AlternateProductForm />} />
          <Route path="/user-form" element={<UserForm />} />
          <Route path="/confirmation" element={<Confirmation />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
